import { billing } from 'libs';
import ExitSurvey from './ExitSurvey';
import type { ExitSurveyPayload, SubscriptionPrice } from './types';

interface DowngradeAddonProps {
  onDowngrade: (subscriptionType: string, data: ExitSurveyPayload) => void;
  onHideModal: () => void;
  price: SubscriptionPrice;
  showModal: boolean;
}

const DowngradeAddon = ({ onDowngrade, onHideModal, price, showModal }: DowngradeAddonProps) => (
  <ExitSurvey
    name={price.name}
    onDowngrade={onDowngrade}
    onHideModal={onHideModal}
    options={billing.addonExitSurveyOptions}
    showModal={showModal}
    subscriptionType={price.subscription_type}
  >
    You can still resume your subscription before the end of your current billing period.
  </ExitSurvey>
);

export default DowngradeAddon;
